import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React from "react";
import ExistingScorecardViewModel from "../ViewModels/ExistingSorecardViewModel";
import TableBody from "@mui/material/TableBody";
import Grid from "@mui/material/Grid";
import ExistingScorecardActionButtons from "./ExistingScorecardActionButtons";
import Box from "@mui/material/Box";

interface IExistingScoreTableProps {
    scorecards: ExistingScorecardViewModel[];
    loadScorecard: (completeId: number) => void;
    scorecardRescoreId?: number;
    checkExistingScorecards: (firstLoad: boolean) => void;
    getScorecardOptions: () => void;
    agentView?: boolean;
    viewPDF: (completeId: number) => void;
}

export default function ExistingScorecardTable(props: IExistingScoreTableProps) {
    return (
        <Grid size={12}>
            <Box sx={{ width: "100%", overflowX: "auto" }}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Template Name</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell>Start Date</TableCell>
                            <TableCell>Monitor Name</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell align="center">Actions</TableCell>
                        </TableRow >
                    </TableHead>
                    <TableBody>
                        {
                            props.scorecards.map((scorecard, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell>{scorecard.templateName}</TableCell>
                                        <TableCell>{scorecard.type}</TableCell>
                                        <TableCell>{scorecard.startDate}</TableCell>
                                        <TableCell>{scorecard.monitorName}</TableCell>
                                        <TableCell>{scorecard.monitoringStatus}</TableCell>
                                        <TableCell>
                                            <ExistingScorecardActionButtons
                                                scorecard={scorecard}
                                                loadScorecard={props.loadScorecard}
                                                checkExistingScorecards={props.checkExistingScorecards}
                                                agentView={props.agentView}
                                                viewPDF={props.viewPDF}
                                            />
                                        </TableCell>
                                    </TableRow >
                                )
                            })
                        }
                    </TableBody>
                </Table>
            </Box>
        </Grid>
    );
}